import { render, staticRenderFns } from "./AnalyseResult.vue?vue&type=template&id=61885e25"
import script from "./AnalyseResult.vue?vue&type=script&lang=js"
export * from "./AnalyseResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports